<template>
  <div class="download" :style="{ height: height }">
    <!-- <img class="app-main" src="@/assets/kiosk/kiosk-background.png" alt="" /> -->
    <img class="app-main" :src="url" alt="" />
    <div class="app-footer">
      <div class="footer-content">
        <div class="footer-main">
          <div class="footer-title">
          </div>
          <div class="button">
            <button class="open-action" @click="handleDownload">立即下载</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDownloadBanner, checkUpdate } from '@/api/kiosk/index'

export default {
  name: 'Download',
  components: {},
  data() {
    return {
      url: '',
      height: document.documentElement.clientHeight + 'px'
    }
  },
  created() {
    this.fetchAdPicture()
  },
  mounted() {
    // launchApp()
    // this.handleDownload()
    console.log(document.documentElement.clientHeight, 'document.documentElement.clientHeight')
  },
  methods: {
    async fetchAdPicture() {
      try {
        const res = await getDownloadBanner({ code: 'cotti-kiosk-download' })
        console.log(res, 'res')
        this.url = res?.data[0]?.url
      } catch (e) {
        console.warn('getDownloadBanner error:', e)
      }
    },
    handleDownload() {
      const params = {
        appChannel: 930,
        currentVersion: 0
      }
      checkUpdate(params).then(res => {
        console.log('res---', res)
        if (res.code === 200) {
          if (res.data?.address) {
            window.location.href = res.data.address
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.download {
  // background: #eeeff0;
  position: relative;
  .app-main {
    width: 100%;
  }
  .app-footer {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    .footer-bg {
      width: 100%;
    }
    .active-border {
      width: 100%;
      height: auto;
    }
    .footer-content {
      font-size: 0;
      img {
        width: 100%;
        position: relative;
        bottom: -1px;
      }
      .footer-title {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 65.4px 0 138.5px 0;
        img {
          width: 64.5%;
        }
      }
      .footer-main {
        position: relative;
        z-index: 1;
        min-height: 407px;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        .button {
          display: flex;
          flex-direction: column;
          .open-action {
            background: #A52337;
            width: 164px;
            height: 34.5px;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 500;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            outline: none;
            margin-top: 40px;
          }
          .install-action {
            width: 542px;
            height: 90px;
            border-radius: 6px;
            background: white;
            border: 1px solid #A52337;
            font-size: 32px;
            font-weight: 500;
            color: #A52337;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}
</style>
